import React, { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import useOdulOneriCall from '../../hooks/useOdulOneriCall'

/**
 * Eski /odul-oneri/uygulama/:token → e-posta oturumu + opex-takip
 */
const UygulamaTokenRedirect = () => {
  const { token } = useParams()
  const { claimTrackingAccess } = useOdulOneriCall()
  const [target, setTarget] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    let mounted = true
    ;(async () => {
      const result = await claimTrackingAccess(token)
      if (!mounted) return
      if (!result.ok) {
        setError(
          result.error === 'expired'
            ? 'Bağlantının süresi dolmuş. Takip ekranından e-posta ile yeniden giriş yapın.'
            : result.error === 'used'
              ? 'Bu bağlantı kullanılmış. Takip ekranından e-posta ile giriş yapın.'
              : 'Geçersiz veya kapalı bağlantı.'
        )
        setTarget('/odul-oneri/opex-takip')
        return
      }
      const q = new URLSearchParams()
      if (result.implementationId) q.set('implementationId', result.implementationId)
      const qs = q.toString()
      setTarget(`/odul-oneri/opex-takip${qs ? `?${qs}` : ''}`)
    })()
    return () => {
      mounted = false
    }
  }, [token, claimTrackingAccess])

  if (target) {
    return <Navigate to={target} replace />
  }

  return (
    <div style={{ padding: '48px 24px', textAlign: 'center', color: '#40516a' }}>
      {error || 'Takip ekranına yönlendiriliyor…'}
    </div>
  )
}

export default UygulamaTokenRedirect
